import { get, isArray } from 'lodash';
import React, { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LoadingBackdrop from '../../../../components/ui-component/loading/LoadingBackdrop';
import MuiSnackbar from '../../../../components/ui-component/mui-snackbar/MuiSnackbar';
import { PostRecord } from '../../../../lib/api/PostRecord';
import { APIS } from '../../../../lib/constants/apis';
import { ANTRAG_BUTTON_NAME, ANTRAGS_STATUS, NOCH_NICHT_MOEGLICH_TEXT, VN_ERSTELLUNG_NOCH_NICHT_MOEGLICH_TEXT } from '../../../../lib/constants/constant';
import { PAGES_URLS } from '../../../../lib/constants/routes';
import { enumT } from '../../../../utils/helper';
import { AntragButton, AntragsButtonWrapper, getMonatListe } from '../FoerderungUebersicht';

// Import Schema
import MUIToolTip from '../../../../components/ui-component/mui-tooltip/MUIToolTip';
import Schema from '../../../../lib/paths/antrag_FULL_Paths.json';
import KostenPostionSchema from '../../../../lib/paths/kostenposition_FULL_Paths.json';
import VerwendungsnachweisSchema from '../../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
const P = Schema.attributes;
const VN_P = VerwendungsnachweisSchema.attributes;
const KP_P = KostenPostionSchema.attributes;

const MessefoerderDashboard: FC<{ application: any }> = ({ application }) => {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [wsError, setWsError] = useState(false);

	const verwendungsnachweis = get(application, P.Foerderantrag_Verwendungsnachweiss.path, []);
	const abschlussbericht = get(application, P.Foerderantrag_Abschlussberichts.path, []);

	const haushaltsJahr = new Date(get(application, P.Angaben_Zur_Messebeteiligung.schema.attributes.Start.path, '')).getFullYear();

	const handleCreateVerwendungsnachweis = async () => {
		const allKostenPostion = get(application, P.Foerderantrag_Kostenpositions.path);
		const VN_Data = {
			Allgemein_Haushaltsjahr: haushaltsJahr,
			Verwendungsnachweisstatus_Status: ANTRAGS_STATUS.inBearbeitung,
			Foerderantrag: get(application, 'id'),
			Allgemein_Foerderquote_Antragstellerin: get(application, P.Orga_Foerderquote_Gesamt.path),
			Bankverbindung_Bank: get(application, P.Antragstellende_Organisation_Bankverbindung_Geldinstitut.path),
			Bankverbindung_IBAN: get(application, P.Antragstellende_Organisation_Bankverbindung_IBAN.path),
			Bankverbindung_BIC: get(application, P.Antragstellende_Organisation_Bankverbindung_BIC.path),
			Ermittlung_Des_Auszahlungsbetrages_Bewilligte_Zuwendung: get(application, P.Bewilligung_Bewilligte_Zuwendung.path, 0),
			Ermittlung_Des_Auszahlun_0254424978_ngen_Im_Gleichen_Projektjahr: get(
				verwendungsnachweis[verwendungsnachweis.length - 1],
				VN_P.Ermittlung_Des_Auszahlungsbetrages_Bereits_Ausgezahlte_Mittel.path,
				0
			),
			Block_1: [
				{
					Zelle_1: get(application, P.Antragstellende_Organisa_0074063902_licher_Name_Der_Organisation.path, ''),
					Zelle_2: get(application, P.Orga_Foerderquote_Gesamt.path, null),
				},
			],
		};
		try {
			setLoading(true);
			let vnRes = await PostRecord(APIS.Verwendungsnachweis, { data: VN_Data });
			if (vnRes) {
				for (let i = 0; i < allKostenPostion.length; i++) {
					const eachKP = allKostenPostion[i];
					const nachweisData = {
						Allgemein_Nr: i + 1,
						Allgemein_Kostentraeger: get(eachKP, KP_P.Allgemein_Kostentraeger.path),
						Allgemein_Unternehmen_Institution: get(eachKP, `${KP_P.Unternehmen.path}.id`),
						Verwendungsnachweis: get(vnRes, 'data.id'),
						Allgemein_Kostenposition: get(eachKP, 'id'),
						Allgemein_Kostenart: get(eachKP, KP_P.Allgemein_Kostenposition.path),
						Allgemein_Bezeichnung: get(eachKP, KP_P.Allgemein_Bezeichnung.path),
						Kostennachweise_Nachweise: [{ Kommentar: '' }],
						Stundennachweis_Geleistete_Stunden: getMonatListe(eachKP),
					};
					await PostRecord(APIS.Nachweisposition, { data: nachweisData });
				}
				navigate(`${PAGES_URLS.OnlineAntrag}`, { state: { id: get(vnRes, 'data.id'), api: APIS.Verwendungsnachweis } });
			}
		} catch (err: any) {
			console.error('ERROR: Creating Verwendungsnachweis ', err);
		} finally {
			setLoading(false);
		}
	};
	const handleCreateAbschlussbericht = async () => {
		// autofold/fold_next

		let abBerichtData = {
			Foerderantrag: get(application, 'id'),
			Abschlussberichtstatus_Abschlussberichtsstatus: ANTRAGS_STATUS.inBearbeitung,
			Antragsteller: get(application, `${P.Antragstellende_Organisation.path}.id`),
			Abschlussbericht_Messefoerderung: {
				Abschlussbericht_Messefoerderung_Name_Der_Messe: get(
					application,
					P.Angaben_Zur_Messebeteiligung.schema.attributes.Projektbeschreibung_Messefoerderung_Messename.path
				),
				Abschlussbericht_Messefoerderung_Datum_Der_Messe: get(application, P.Angaben_Zur_Messebeteiligung.schema.attributes.Start.path),
				Abschlussbericht_Messefoerderung_Standflaeche_Messe: get(
					application,
					P.Angaben_Zur_Messebeteiligung.schema.attributes.Projektbeschreibung_Messefoerderung_Standflaecheqm.path
				),
			},
		};
		try {
			setLoading(true);
			let res = await PostRecord(APIS.Abschlussbericht, { data: abBerichtData });
			if (res) navigate(PAGES_URLS.OnlineAntrag, { state: { id: get(res, 'data.id'), api: APIS.Abschlussbericht } });
		} catch (err: any) {
			setWsError(true);
			console.error('ERROR: Creating Abschlussbericht ', err);
		} finally {
			setLoading(false);
		}
	};

	const RenderVerwendungsnachweisButton: FC<{}> = () => {
		if (isArray(verwendungsnachweis) && verwendungsnachweis.length > 0) {
			const isLastNachweisFrei =
				get(verwendungsnachweis[verwendungsnachweis.length - 1], VN_P.Verwendungsnachweisstatus_Status.path) === ANTRAGS_STATUS.freigegeben ?
					true
				:	false;
			return (
				<AntragsButtonWrapper title='Mittelabruf und Verwendungsnachweis:'>
					{verwendungsnachweis.map((eachVN: any, i: number) => {
						return (
							<AntragButton
								key={i}
								name={`Verwendungsnachweis`}
								description={enumT(get(eachVN, VN_P.Verwendungsnachweisstatus_Status.path, ''))}
								onClick={() =>
									navigate(PAGES_URLS.OnlineAntrag, {
										state: {
											id: get(eachVN, `id`),
											api: APIS.Verwendungsnachweis,
										},
									})
								}
							/>
						);
					})}

					{get(application, P.Antragstatus_Antragstatus.path, '') === ANTRAGS_STATUS.inFoerderung && (
						/* VN-Erstellung temporär für alle Programme deaktiviert (ursprünglich: disabled={!isLastNachweisFrei}) */
						<MUIToolTip title={VN_ERSTELLUNG_NOCH_NICHT_MOEGLICH_TEXT} showTootip={true}>
							<AntragButton
								name='Verwendungsnachweis'
								description={'Verwendungsnachweis erstellen'}
								onClick={handleCreateVerwendungsnachweis}
								disabled={true || !isLastNachweisFrei}
								variant={'contained'}
							/>
						</MUIToolTip>
					)}
				</AntragsButtonWrapper>
			);
		} else {
			if (get(application, P.Antragstatus_Antragstatus.path, '') === ANTRAGS_STATUS.inFoerderung) {
				return (
					<AntragsButtonWrapper title='Mittelabruf und Verwendungsnachweis:'>
						{/* VN-Erstellung temporär für alle Programme deaktiviert. */}
						<MUIToolTip title={VN_ERSTELLUNG_NOCH_NICHT_MOEGLICH_TEXT} showTootip={true}>
							<AntragButton
								name='Verwendungsnachweis'
								description='Verwendungsnachweis erstellen'
								onClick={handleCreateVerwendungsnachweis}
								variant={'contained'}
								disabled={true}
							/>
						</MUIToolTip>
					</AntragsButtonWrapper>
				);
			} else {
				return (
					<AntragsButtonWrapper title={'Mittelabruf und Verwendungsnachweis:'}>
						<AntragButton name={NOCH_NICHT_MOEGLICH_TEXT} description='offen' onClick={() => {}} disabled={true} />
					</AntragsButtonWrapper>
				);
			}
		}
	};
	const RenderAbschlussberichtButton: FC<{}> = () => {
		// autofold/fold_next

		if (isArray(abschlussbericht) && abschlussbericht.length > 0) {
			return (
				<AntragsButtonWrapper title='Abschlussbericht:'>
					{abschlussbericht.map((eachAbschlussbericht: any, i: number) => {
						return (
							<AntragButton
								key={i}
								name='Abschlussbericht'
								description='Ansehen'
								onClick={() =>
									navigate(`${PAGES_URLS.OnlineAntrag}`, {
										state: { id: get(eachAbschlussbericht, 'id'), api: APIS.Abschlussbericht },
									})
								}
							/>
						);
					})}
				</AntragsButtonWrapper>
			);
		} else {
			if (get(application, P.Antragstatus_Antragstatus.path, '') === ANTRAGS_STATUS.ProjektBeendet) {
				return (
					<AntragsButtonWrapper title='Abschlussbericht:'>
						<AntragButton name='Abschlussbericht' description='Abschlussbericht erstellen' onClick={handleCreateAbschlussbericht} variant='text' />
					</AntragsButtonWrapper>
				);
			} else {
				return (
					<AntragsButtonWrapper title='Abschlussbericht:'>
						<AntragButton name={NOCH_NICHT_MOEGLICH_TEXT} description='offen' onClick={() => {}} variant='text' disabled={true} />
					</AntragsButtonWrapper>
				);
			}
		}
	};

	return (
		<>
			<LoadingBackdrop open={loading} />
			<MuiSnackbar showSnackbar={wsError} closeSnackbar={() => setWsError(false)} alertMessage='Etwas ist schief gelaufen' />
			<AntragsButtonWrapper title='Antrag:'>
				<AntragButton
					name={get(application, P.Allgemein_Projekttitel.path) ? get(application, P.Allgemein_Projekttitel.path) : ANTRAG_BUTTON_NAME}
					description={enumT(get(application, P.Antragstatus_Antragstatus.path))}
					onClick={() =>
						navigate(PAGES_URLS.OnlineAntrag, {
							state: {
								id: get(application, 'id'),
								api: APIS.Antrag,
								antragsformular: get(application, P.Allgemein_Antragsformular.path),
							},
						})
					}
				/>
			</AntragsButtonWrapper>

			<RenderVerwendungsnachweisButton />

			<RenderAbschlussberichtButton />
		</>
	);
};

export default MessefoerderDashboard;
